import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { UserAccess } from './user-access.model';
import { RequestTime } from './request-time.model';

@Injectable()
export class UserAccessService extends BaseService {

  constructor(protected http: HttpClient, protected router: Router, protected cookieService: CookieService){
    super( http, router, cookieService );
  }

  public update(access: UserAccess): Observable<UserAccess>{

    return this.put<UserAccess>( `/user-accesses/${ access.id }`, access, this.httpOptions() );
  }

  public create(userAccess: UserAccess, user: string): Observable<UserAccess>{
    let params: HttpParams = new HttpParams();

    if ( !!user ) {
      params = params.append( 'userId', user );
    }

    return this.post<UserAccess>( `/user-accesses`, userAccess, this.httpOptions( params ) );
  }

  public requestTime(userAccess: UserAccess): Observable<UserAccess>{

    return this.post<UserAccess>( `/user-accesses/${ userAccess.id }/request-time`, userAccess, this.httpOptions() );
  }

  public replyAccessTime(userAccess: UserAccess, replyAccess: RequestTime): Observable<UserAccess>{

    return this.post<UserAccess>( `/user-accesses/${ userAccess.id }/request-time/${ replyAccess.id }`, userAccess, this.httpOptions() );
  }

  public getUserAccesses(userId?: string, association?: string): Observable<UserAccess[]>{
    let params: HttpParams = new HttpParams();

    if ( !!userId ) {
      params = params.append( 'userId', userId );
    }

    if ( !!association ) {
      params = params.append( 'association', association );
    }

    return this.get<UserAccess[]>( `/user-accesses`, this.httpOptions( params ) );
  }

  public getLoggedInUserAccesses(): Observable<UserAccess[]>{
    return this.get<UserAccess[]>( `/user-accesses/logged-in`, this.httpOptions( ) );
  }
}
